export default "/images/32da7e7a97beb70269c2d76a457b71ff.avif";